import React from 'react'
import NavBar from '../components/NavBar';
import TitleCard from '../components/TitleCard';
import Footer from '../components/Footer';
import GridGallery from '../screens/GridGallery';
const GalleryPage = () => {
  return (
    <>
        <NavBar/>
        <TitleCard heading="Photo Gallery" subHeading="Capturing Moments from Our Conservation Endeavors"/>
        <GridGallery />
        <Footer />
    </>
  )
}

export default GalleryPage